module.exports = __webpack_public_path__ + "img/back-manual.cb658e8e.png";